<template>
  <el-main>
    <el-row>
      <el-col :offset="14" :xs="10" :sm="10" :md="10" :lg="10" :xl="10" :span="1">
        <el-form ref="form" :model="form" label-width="100px" style="float: right" :inline="true">
          <el-form-item label="按标签搜索:">
            <el-input v-model="form.name" placeholder="请输入标签过滤"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="iik">过滤</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="padding-bottom: 20px">
      <template v-for="(item,index) in proList">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :span="1" :key="index">
          <div class="grid-content bg-purple">
            <el-card class="box-card" :body-style="{ height: 'auto', overflowY:'auto',marginBottom:'10px'}">
              <div slot="header" class="clearfix" style="position: relative">
                <strong class="product-title"><span>{{item.NAME}}</span></strong>
              </div>
              <el-row>
                <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" :span="1">
                  <el-image class="img-back" :src="url+Math.ceil( Math.random() * 10 ) "></el-image>
                </el-col>
                <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" :span="1">
                  <div class="text item text-indice product-intro">{{item.INTRODUCTION}}</div>
                </el-col>
              </el-row>

            </el-card>
            <div class="foot-label">
              <span class="">{{item.CREATE_TIME}}</span>
              <span class="tag-label">标签：{{item.TAG}}</span>
              <a target="_blank" v-bind:href="item.LINK?item.LINK:item.LINK_TB">
                <el-button style="float: right; padding: 3px 24px"
                           type="text">
                  <span v-if="item.LINK_TB!==''">
                    <el-link :href="item.LINK_TB" target="_blank" type="primary">链接直达</el-link>
                  </span>
                  <span v-if="item.TYPE!==''">
                    <el-link :href="downloadUrl+item.LINK" target="_blank" type="success">直接下载</el-link>
                  </span>
                </el-button>
              </a>
            </div>
          </div>
        </el-col>

      </template>
    </el-row>
  </el-main>
</template>

<script>
  import {queryProductByType} from '../../../services/commericalService'
  import {host, local} from "../../../vue.config";

  export default {
    name: "productTemplate",
    props: ['type'],
    data() {
      return {
        form: {
          name: ""
        },
        url: 'http://placekitten.com/80/80?image=',
        storeList: [],
        proList:
          [],
        downloadUrl: local + "/uploadFile",
        isCollapse: false,
      };
    },
    created() {
      let that = this;
      queryProductByType({
        type: this.type
      }).then(function (result) {
        that.proList = result.data.data.list;
        that.storeList = result.data.data.list;
      })
    },
    methods: {
      iik() {
        let filterName = this.form.name;
        this.proList = this.storeList;
        if (filterName) {
          let list = this.proList;
          let filterList = [];
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item.TAG.indexOf(filterName) > -1) {
              filterList.push(item);
            }
          }
          this.proList = filterList;
        } else {
          this.proList = this.storeList;
        }

      }
    }
  }
</script>

<style scoped>
  .el-card__header {
    padding: 6px 20px !important;
  }

  .foot-label {
    position: relative;
    top: -25px;
    left: 10px;
    color: gray;
  }

  .tag-label {
    color: #ff5722;
    font-weight: bold;
  }

  .text-indice {
    text-indent: 2em;
  }

  .product-title {
    color: #673ab7;
    text-transform: capitalize;
    font-size: 1.2em;
  }

  .product-intro {
    color: #000;
  }

  .img-back {
    width: 80px;
    height: 80px;
    background-color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/commerical/widget/productTemplate.vue